// 点击复制到剪贴板函数
export function copyToClipboard(content, _this) {
  if (window.clipboardData) {
    window.clipboardData.setData("text", content);
  } else {
    (function(content) {
      document.oncopy = function(e) {
        e.clipboardData.setData("text", content);
        e.preventDefault();
        document.oncopy = null;
      };
    })(content);
    document.execCommand("Copy");
  }
  _this.$Message["success"]({
    background: true,
    content: _this.$t("copy") + _this.$t("success"),
    duration: 5
  });
}

export default { copyToClipboard };
